import { useEffect, useState } from "react";
import {
  createCategoriaReporte,
  updateCategoriaReporte,
} from "../../components/functions/Projects";
import LoaderDialog from "../../ui/loader/Loader";
import { DialogActions, Snackbar, Dialog } from "@mui/material";
import CustomButton from "../../ui/button/Button";

const EDTCategoriaReporteModal = ({
  API_URL,
  open,
  handleClose,
  selectedEDT,
  edit = false,
  categoria = null,
}) => {
  const [showLoader, setShowLoader] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [categoriaForm, setCategoriaForm] = useState({
    nombre: "",
    descripcion: "",
    tipoTrabajo: {
      id: null,
    },
  });

  const [categoriaFormEdit, setCategoriaFormEdit] = useState({
    nombre: "",
    descripcion: "",
    tipoTrabajo: {
      id: null,
      nombre: null,
      tipoTrabajoClonar: null,
    },
    id: null,
    orden: null,
  });

  useEffect(() => {
    if (open && selectedEDT) {
      if (edit && categoria) {
        setCategoriaFormEdit({
          ...categoria,
          tipoTrabajo: {
            id: selectedEDT.id,
            nombre: null,
            tipoTrabajoClonar: null,
          },
        });
      } else {
        setCategoriaForm({
          nombre: "",
          descripcion: "",
          tipoTrabajo: {
            id: selectedEDT.id,
          },
        });
      }
    }
    // eslint-disable-next-line
  }, [open, selectedEDT]);

  const onClose = () => {
    handleClose();
    setCategoriaForm({
      nombre: "",
      categoriaParametro: null,
      tipoTrabajo: {
        id: null,
      },
    });
    setCategoriaFormEdit({
      nombre: "",
      descripcion: "",
      tipoTrabajo: {
        id: null,
        nombre: null,
        tipoTrabajoClonar: null,
      },
      id: null,
      orden: null,
    });
    setShowLoader(false);
  };

  async function crearCategoria() {
    if (
      (!edit && categoriaForm.nombre.trim() === "") ||
      (edit && categoriaFormEdit.nombre.trim() === "")
    ) {
      setShowSnackbar(true);
      setSnackbarMessage(
        "El nombre de la categoría de reporte es obligatorio."
      );
      return;
    }

    try {
      setShowLoader(true);
      if (edit) {
        await updateCategoriaReporte(API_URL, categoriaFormEdit);
      } else {
        await createCategoriaReporte(API_URL, categoriaForm);
      }
      setShowLoader(false);
      onClose();
    } catch (error) {
      setShowLoader(false);
      setShowSnackbar(true);
      setSnackbarMessage(
        `Ocurrió un error al ${
          edit ? "actualizar" : "crear"
        } la categoría de reporte.`
      );
    }
  }

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        onClose={onClose}
        open={open}
        disableEnforceFocus
      >
        <Snackbar
          open={showSnackbar}
          autoHideDuration={3000}
          onClose={() => {
            setShowSnackbar(false);
            setSnackbarMessage("");
          }}
          message={snackbarMessage}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          slotProps={{
            content: {
              sx: {
                backgroundColor: "white",
                color: "#222",
                justifyContent: "center",
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "16px",
                fontFamily: "Roboto, Arial, sans-serif",
              },
            },
          }}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            margin: "0",
            padding: "12px",
          }}
        >
          <h2>{edit ? "Editar" : "Crear"} categoría de reporte</h2>
          <label htmlFor="name2" className="form-label form-label-left">
            Nombre:
          </label>
          <input
            id="name2"
            className="form-input"
            type="text"
            name="nombre"
            placeholder="Ingresa el nombre..."
            value={edit ? categoriaFormEdit.nombre : categoriaForm.nombre}
            onChange={(e) => {
              if (edit) {
                setCategoriaFormEdit((prev) => ({
                  ...prev,
                  nombre: e.target.value,
                }));
              } else {
                setCategoriaForm((prev) => ({
                  ...prev,
                  nombre: e.target.value,
                }));
              }
            }}
          />

          <label htmlFor="desc2" className="form-label form-label-left">
            Descripción:
          </label>
          <input
            id="desc2"
            className="form-input"
            type="text"
            name="descripcion"
            placeholder="Ingresa la descripcion..."
            value={
              edit ? categoriaFormEdit.descripcion : categoriaForm.descripcion
            }
            onChange={(e) => {
              if (edit) {
                setCategoriaFormEdit((prev) => ({
                  ...prev,
                  descripcion: e.target.value,
                }));
              } else {
                setCategoriaForm((prev) => ({
                  ...prev,
                  descripcion: e.target.value,
                }));
              }
            }}
          />
        </div>
        <DialogActions>
          <CustomButton
            background={"#FFFFFF"}
            color={"#223D51"}
            text="Cerrar"
            height="40px"
            fontWeight="700"
            fontSize="14px"
            border="1px solid #D9D9D9"
            onClick={onClose}
            type="button"
          />
          <CustomButton
            background={"#223D51"}
            color={"#FFFFFF"}
            text="Guardar"
            height="40px"
            fontWeight="700"
            fontSize="14px"
            border="1px solid #D9D9D9"
            onClick={crearCategoria}
            type="button"
          />
        </DialogActions>
      </Dialog>
      <LoaderDialog open={showLoader} />
    </>
  );
};

export default EDTCategoriaReporteModal;
